import React from 'react';
import './PartnerCarousel.css';

export const PartnerCarousel = () => {
  const partners = [
    {
      name: 'NewStreet',
      logo: 'https://customer-assets.emergentagent.com/job_realestate-ai-blog/artifacts/fhg2arz5_NewStreet.webp',
      url: 'https://www.newstreet.ch'
    },
    {
      name: 'St. Galler Kantonalbank',
      logo: 'https://customer-assets.emergentagent.com/job_realestate-livag/artifacts/k5kx90y6_SGKB%20Logo.webp',
      url: 'https://www.sgkb.ch'
    },
    {
      name: 'Schweizer Nachfolge',
      logo: 'https://customer-assets.emergentagent.com/job_realestate-ai-blog/artifacts/qrr5a72p_SN_Wortmarke_final_Dez22.webp',
      url: 'https://www.schweizernachfolge.ch'
    },
    {
      name: 'Clientis Oberuzwil',
      logo: 'https://customer-assets.emergentagent.com/job_realestate-ai-blog/artifacts/4s15pizx_Clientis.webp',
      url: 'https://www.oberuzwil.clientis.ch'
    },
    {
      name: 'AdaCon',
      logo: 'https://customer-assets.emergentagent.com/job_realestate-ai-blog/artifacts/q0l8bl1m_Adacon_Logo.webp',
      url: 'https://www.adacon.ch'
    }
  ];

  // Duplicate partners for seamless infinite scroll
  const duplicatedPartners = [...partners, ...partners, ...partners];

  return (
    <section className="partner-carousel-section">
      <div className="py-6">
        <h2 className="text-2xl md:text-3xl font-normal text-white text-center mb-6 px-4 sm:px-6 lg:px-8" style={{ fontFamily: "'Playfair Display', serif" }}>
          Unsere Partner - Ihr neues Netzwerk.
        </h2>
        <div className="partner-carousel-fullwidth">
          <div className="partner-carousel-track">
            {duplicatedPartners.map((partner, index) => (
              <a 
                key={index} 
                href={partner.url}
                target="_blank"
                rel="noopener noreferrer"
                className="partner-logo-container"
              >
                <img
                  src={partner.logo}
                  alt={`${partner.name} - Partner von LIVAG AG für Immobilien in St. Gallen`}
                  title={`${partner.name} - LIVAG Partnernetzwerk Ostschweiz`}
                  loading="lazy"
                  width="120"
                  height="60"
                  className="partner-logo"
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
